import { all, create, factory } from 'mathjs';

function equal(a: unknown, b: unknown) {
  return a == b;
}

function unequal(a: unknown, b: unknown) {
  return a != b;
}

/**
 * Shared math.js instance. Import from here instead of the mathjs barrel so AST helpers
 * do not create a circular import with unit/extension setup.
 */
export const mathJS = create(
  {
    ...all,
    // Override equal to support strings and booleans
    createEqual: factory('equal', [], () => equal),
    // Override unequal to support strings and booleans
    createUnequal: factory('unequal', [], () => unequal),
  },
  {
    predictable: true,
  },
);
